module.exports = __webpack_public_path__ + "static/media/leak-pod-offline.10a4577c.svg";